import { DataService } from "./dataService"

class ApiService extends DataService {

    constructor(ruta: string) {
        const metaElement = document.getElementsByName("api")[0] as HTMLMetaElement
        
        ruta = metaElement.content + ruta

        super(ruta)
    }

    formatParams(params){
        const { pagina, matchExacto, itemsPorPag, ...model } = params
        return { model, matchExacto, itemsPorPag }
    }

    // Para reducir código, implementar en clase base el método de formateo para no 
    // especificar el get en cada clase que retorne propiedades json
    get(params = {}) {

        const getParams = this.formatParams(params)

        return super.get(getParams)
    }
}

class DatosDeContenidoApi extends ApiService {

    constructor(id: number = null) {
        super("datosDeContenido")
        this.id = id
    }

    id: number

    formatDatos(datos) {
        return {
            datos: JSON.stringify(datos),
            idContenido: this.id
        }
    }

    formatParams(params) {
        const { pagina, matchExacto, busqueda, itemsPorPag, ...datos } = params
        const model = this.formatDatos(datos)
        return { model, matchExacto, busqueda, itemsPorPag }
    }

    // Nombre temporal Hasta hacer clase independiente con "getById"
    getByContenidoId(id: number) {
        return this.get(
            {
                id,
                matchExacto: true
            })
    }

    post(data = {}) {
        const model = this.formatDatos(data)
        return super.post(model)
    }
}

class ContenidosApi extends ApiService {
    constructor() {
        super("contenidos")
    }

    format(contenido) {

        for (const prop in contenido.data) {
            const valor = contenido.data[prop]
            contenido[prop] = valor ? JSON.parse(valor) : undefined
        }

        return contenido
    }

    get(params = {}) {
        const datos = new DatosDeContenidoApi()

        return datos.get(params).then(items => {
            return items.map(item => this.format(item))
        })
    }
}

export { ApiService, ContenidosApi, DatosDeContenidoApi }